module.exports = __webpack_public_path__ + "img/Feature.d53354a4.jpg";